import { plugin as vueTransitionsPlugin } from '@morev/vue-transitions'
import ui from '@nuxt/ui/vue-plugin'
import { setupSentry } from 'app/plugins/sentry'

import { setupI18n } from 'i18n/index'

import { vMaska } from 'maska'
import { createApp } from 'vue'
import App from './App.vue'
import { registerModules } from './providers/register-modules'
import { router } from './providers/router/router'
import { store } from './providers/store'
import 'mechtaui/style'
import './assets/main.css'
import '@morev/vue-transitions/styles'

export async function initialize() {
  const app = createApp(App)
  app.use(store)

  app.directive('maska', vMaska)
  registerModules(router)
  await setupI18n(app)
  app.use(router)
  app.use(ui)
  app.use(vueTransitionsPlugin({}))
  setupSentry(app)
  app.mount('#app')
}
